module.exports = __webpack_public_path__ + "fdea545bee8d5a77816ade991529554d.svg";